/* Wavy tape marquee: draws the band polygon and bends each item along the
   same sine wave (translateY + rotate), so the text follows the tape. */
(function () {
  var TAU = Math.PI * 2;

  function init(marquee) {
    if (marquee.dataset.waveInit) return;
    var svg = marquee.querySelector('.marquee__svg');
    var poly = svg && svg.querySelector('polygon');
    if (!poly) return;
    marquee.dataset.waveInit = '1';

    var w, h, amp, half, lambda, items, visible = true;

    function wave(x) { return amp * Math.sin((TAU * x) / lambda); }
    function slope(x) { return amp * (TAU / lambda) * Math.cos((TAU * x) / lambda); }

    function layout() {
      var r = marquee.getBoundingClientRect();
      w = r.width;
      h = r.height;
      amp = h * 0.16;
      half = (h - 2 * amp - 8) / 2;
      lambda = Math.max(w * 1.05, 640);
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      var top = [], bottom = [], x;
      for (x = -10; x <= w + 10; x += 16) {
        top.push(x + ',' + (h / 2 - half + wave(x)).toFixed(1));
        bottom.unshift(x + ',' + (h / 2 + half + wave(x)).toFixed(1));
      }
      poly.setAttribute('points', top.concat(bottom).join(' '));
      items = marquee.querySelectorAll('.marquee__char, .marquee__icon');
    }

    /* Split each item into per-letter spans so every character follows the
       wave on its own and the words bend with the tape. */
    marquee.querySelectorAll('.marquee__item').forEach(function (item) {
      if (item.dataset.split) return;
      item.dataset.split = '1';
      var text = item.textContent;
      item.textContent = '';
      for (var i = 0; i < text.length; i++) {
        var ch = document.createElement('span');
        ch.className = 'marquee__char';
        ch.setAttribute('aria-hidden', 'true');
        ch.textContent = text.charAt(i);
        item.appendChild(ch);
      }
      item.setAttribute('aria-label', text);
    });

    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function frame() {
      if (visible) {
        var left = marquee.getBoundingClientRect().left;
        var n = items.length, xs = new Array(n), i, r, cx;
        for (i = 0; i < n; i++) {
          r = items[i].getBoundingClientRect();
          xs[i] = r.left + r.width / 2 - left;
        }
        for (i = 0; i < n; i++) {
          cx = xs[i];
          if (cx < -200 || cx > w + 200) continue;
          items[i].style.transform =
            'translateY(' + wave(cx).toFixed(2) + 'px) rotate(' +
            (Math.atan(slope(cx)) * 180 / Math.PI).toFixed(2) + 'deg)';
        }
      }
      if (!still) requestAnimationFrame(frame);
    }

    layout();
    window.addEventListener('resize', layout);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(marquee);
    }
    requestAnimationFrame(frame);
    if (still) window.addEventListener('resize', frame);
  }

  function initAll() { document.querySelectorAll('.munchief .marquee').forEach(init); }
  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
